export default "__VITE_ASSET__9557e92f__"